<template>
	<div class="box">
		<CustomTable
            ref="table"
            id_table="ca_semence_stallions"
            primaryKey="horse_id"
            :items="stallions"
            :hrefsRoutes="config_table_hrefs"
            :busy.sync="table_busy"
            :display_action_button="false"
            :checkboxes="false"
        />
	</div>
</template>

<script type="text/javascript">
	import Semence from "@/mixins/Semence.js"

	export default {
		name: 'Stallions',
		mixins: [Semence],
		data () {
			return {
				table_busy: false,
				stallions: [],
                config_table_hrefs: {
                    'horse_nom': {
                        routeUniqueName: 'StallionStocks',
                        routeName: 'StallionStocks',
                        params: {
                            horse_id: 'horse_id'
                        }
                    }
                }
			}
		},

		mounted() {
			this.init_component()
		},

		methods: {
			async init_component() {
				this.table_busy = true
				this.stallions = await this.getStallions()
				this.table_busy = false
			},
		},

		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
		}
	}

</script>